export const isMobile = () => {
    return (window.screen.width < 768 ? true : false)
};

export const isDeviceType = () =>{
    const regex = /Mobi|Android|webOS|iPhone|iPad|BlackBerry|IEMobile|Opera Mini/i;
    return regex.test(navigator.userAgent);
};